const CONTROL_KEYSCODES = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Tab'];
const ONLY_NUMBER_REGEX = '^[0-9]*$';
export default function validateNumber(event: any) {
  if (event == null || event.data == null) return;

  const value = event.data;

  //Excluir caracteres de borrado y posicionamiento
  if (CONTROL_KEYSCODES.includes(value)) return;

  if (!value.match(ONLY_NUMBER_REGEX)) event.preventDefault();
}
